export default __webpack_public_path__ + "static/media/500.ebb42993.svg";